module.exports = "/_next/static/images/nile_in-a07b9e703a94c5de641fe2b0545b5d37.jpg";